import React from 'react';
import { MobileIcon } from '@revfluence/fresh-icons/solid/esm';
import { GetAllStagesQuery_getAllStages } from '@frontend/app/queries/types/GetAllStagesQuery';
import { TProject, TWorklet } from '../../types';
import { PreviewHeader } from './PreviewHeader';
import { TaskList } from './TaskList';

interface Props {
  project?: TProject;
  stages?: TWorklet[];
  isLoading?: boolean;
  customStages?: GetAllStagesQuery_getAllStages[];
}

export const CreatorPortalPreview: React.FC<Props> = ({ project, stages, isLoading, customStages }) => {
  return (
    <div className="flex h-full flex-col border-l border-border p-6">
      <div className="mb-4 flex items-center gap-2">
        <div className="flex h-6 w-6 items-center justify-center rounded-md bg-grey-6">
          <MobileIcon className="h-3 w-3 text-white" />
        </div>
        <h2 className="mb-0 text-lg font-medium text-grey-6">
          Creator Portal Preview
        </h2>
      </div>

      {/* Device Frame */}
      <div className="flex-1 overflow-hidden rounded-[52px] border-2 border-grey-2 bg-grey-1 shadow-[0px_2px_6px_-4px_hsla(0,0%,0%,0.12),0px_4px_8px_0px_hsla(209,11%,41%,0.08),0px_8px_24px_8px_hsla(209,11%,41%,0.05)]">
        <div className="h-full w-full overflow-y-auto rounded-[44px]">
          <PreviewHeader project={project} />
          <TaskList stages={stages} isLoading={isLoading} customStages={customStages} />
        </div>
      </div>
    </div>
  );
};
